import { jsx } from '@amazon/vinyl-tsx'
import { data } from '@amazon/vinyl-observable'
import { LoadingIndicator } from '@/components/LoadingIndicator'
import { Modal } from '@/components/Modal'
import { openModal } from '@/components/modalLayer'
import { getString } from '@/auth/i18n/bundle.generated'
import { getString as getComponentString } from '@/components/i18n/bundle.generated'

/**
 * Blocks the page while a sign-in popup or window is open, so the customer sees the sign-in is
 * waiting on them. Cancel (or Escape) runs `onCancel` and closes it, for a popup hidden behind the
 * app; the returned function closes it once the sign-in ends.
 */
export function openSigningInModal(onCancel: () => void): () => void {
    const handle = openModal({
        render: (close) => {
            const visible = data(true)
            const finish = () => {
                visible.value = false
                queueMicrotask(close)
            }
            const cancel = () => {
                onCancel()
                finish()
            }
            return (
                <Modal
                    className="confirmModal signingInModal"
                    visible={visible}
                    dismissible={false}
                    role="dialog"
                    aria-busy="true"
                    aria-label={getString('dmusic_signing_in_title')}
                    onClose={(reason) => {
                        if (reason === 'keypress') cancel()
                    }}
                >
                    <h2 className="confirmModalTitle">{getString('dmusic_signing_in_title')}</h2>
                    <LoadingIndicator />
                    <div className="confirmModalActions">
                        <button
                            type="button"
                            className="textButton"
                            autofocus={true}
                            onclick={cancel}
                        >
                            {getComponentString('dmusic_cancel_button_text')}
                        </button>
                    </div>
                </Modal>
            )
        },
    })
    return handle.close
}
